import { Route, Routes, useLocation } from 'react-router-dom';

import LoginRoutes from 'routes/LoginRoutes';
import { MonitoringRoutes } from 'routes/monitoring';
import PrivateRoute from 'components/route/PrivateRoute';
import { MenuInfo } from 'data';
import Error403 from 'pages/Error403';
import JoinRoutes from 'routes/JoinRoutes';
import usePermission from 'hooks/usePermission';
import RootRedirect from 'RootRedirect';
import PageTest from 'pages/PageTest';

export default function RootRoutes() {
    const monitoring = MenuInfo.CMMS;

    const { hasPermission } = usePermission();
    
    const monitoringVisible =
        (!monitoring.permission || hasPermission(monitoring.permission)) &&
        (monitoring.feature === undefined || monitoring.feature);
    // console.log(monitoringVisible)

    return (
        <Routes>
            <Route path="/" element={<RootRedirect />} />

            <Route element={<PrivateRoute auth={false} />}> {/* 로그인 하지 않아야 접근 가능 */}
                <Route path={"/auth/*"} element={<LoginRoutes />} errorElement={<Error403 />} />
            </Route>

            <Route element={<PrivateRoute auth={false} join={true} />}> {/* 로그인 하지 않아야 접근 가능 */}
                <Route path={"/join/*"} element={<JoinRoutes />} errorElement={<Error403 />} />
            </Route>

            <Route path="pageTest" element={ <PageTest /> }/>
            {/* <Route path="chinaMapTest" element={ <ChinaMapWithSearch /> }/>
            <Route path="VideoWithOverlay" element={ <VideoWithOverlay /> }/> */}

            <Route element={<PrivateRoute auth={true} />}> {/* 로그인 해야 접근 가능 */}
                {monitoringVisible &&
                    <Route path={monitoring.fullpath + "*"} element={ 
                        <MonitoringRoutes/>
                    }/>
                }
            </Route>
        </Routes>
    );
}